import { motion } from "framer-motion";
import { CASH } from "@/constants/testIds";
import TiltCard from "@/components/TiltCard";
import Divider from "@/components/Divider";

const BLOCKS = [
    {
        letter: "C",
        title: "Content",
        tid: CASH.blockC,
        copy: "We audit and refine what you post so every piece is built to perform, not just to exist on your feed.",
    },
    {
        letter: "A",
        title: "Amplify",
        tid: CASH.blockA,
        copy: "Organic distribution systems push your content to the right audience, multiplying reach without a single ad dollar.",
    },
    {
        letter: "S",
        title: "Sell",
        tid: CASH.blockS,
        copy: "Reach is converted into enquiries and sales through strategic positioning, offers, and profile optimisation.",
    },
    {
        letter: "H",
        title: "Hook",
        tid: CASH.blockH,
        copy: "Retention systems keep your audience coming back, turning casual viewers into followers, and followers into buyers.",
    },
];

export default function CashFramework() {
    return (
        <section
            id="framework"
            data-testid={CASH.root}
            className="relative py-20 md:py-28"
        >
            <Divider label="framework" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto">
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        Our Proprietary System
                    </p>
                    <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--text-primary)]">
                        The{" "}
                        <span className="gold-shimmer italic">C.A.S.H</span> Strategy
                    </h2>
                    <p className="mt-6 text-lg text-[var(--text-secondary)]">
                        Four interlocking systems. One outcome: reach that becomes revenue.
                    </p>
                </div>

                <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 perspective-1500">
                    {BLOCKS.map((b, i) => (
                        <motion.div
                            key={b.letter}
                            initial={{ opacity: 0, y: 40, rotateX: -8 }}
                            whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.8, delay: i * 0.12 }}
                        >
                            <TiltCard intensity={8} lift={14}>
                                <div
                                    data-testid={b.tid}
                                    className="surface-3d relative rounded-3xl p-8 md:p-10 min-h-[280px] md:min-h-[320px] flex flex-col justify-between overflow-hidden"
                                >
                                    <div className="absolute -top-6 -right-4 font-display text-[10rem] md:text-[13rem] font-bold leading-none text-white/[0.06] select-none">
                                        {b.letter}
                                    </div>
                                    <div className="relative">
                                        <div className="flex items-baseline gap-3 mb-6">
                                            <span className="font-display text-6xl md:text-7xl font-bold gold-shimmer">
                                                {b.letter}
                                            </span>
                                            <span className="font-fraktur text-[var(--accent-champagne)]/60 text-xl md:text-2xl">
                                                {b.title.toLowerCase()}
                                            </span>
                                        </div>
                                        <h3 className="font-display text-3xl md:text-4xl font-bold text-[var(--text-primary)] mb-3">
                                            {b.title}
                                        </h3>
                                        <p className="text-[var(--text-secondary)] leading-relaxed">
                                            {b.copy}
                                        </p>
                                    </div>
                                </div>
                            </TiltCard>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
